const actions = {
  SET_LEAD_LISTINGS_TABLE_DATA: 'SET_LEAD_LISTINGS_TABLE_DATA',
  SET_SELECTED_USER: 'SET_SELECTED_USER',
  LEADS_BREAKDOWN_DATA_BEGIN: 'LEADS_BREAKDOWN_DATA_BEGIN',
  LEADS_BREAKDOWN_DATA_ERROR: 'LEADS_BREAKDOWN_DATA_ERROR',
  LEADS_BREAKDOWN_DATA_SUCCESS: 'LEADS_BREAKDOWN_DATA_SUCCESS',
  SET_LEADS_BREAKDOWN_FILTERS: 'SET_LEADS_BREAKDOWN_FILTERS',

  setSelectedUser: (userId) => {
    return {
      type: 'SET_SELECTED_USER',
      payload: userId,
    };
  },
  fetchLeadsBreakdownBegin: () => {
    return {
      type: actions.LEADS_BREAKDOWN_DATA_BEGIN,
      payload: { loading: true },
    };
  },

  fetchLeadsBreakdownSuccess: (data) => {
    return {
      type: actions.LEADS_BREAKDOWN_DATA_SUCCESS,
      payload: { data, loading: false, error: null },
    };
  },

  fetchLeadsBreakdownErr: (err) => {
    return {
      type: actions.LEADS_BREAKDOWN_DATA_ERROR,
      payload: { loading: false, error: err },
    };
  },
  setLeadsBreakdownFilters: (filtersObj) => {
    return {
      type: actions.SET_LEADS_BREAKDOWN_FILTERS,
      payload: filtersObj,
    };
  },
};

export default actions;
